<div
  class="flex flex-col min-h-screen"
  style="margin-top: 1rem; padding: 0 1rem"
  *transloco="let t; prefix: 'providerRegister'"
>
  <div class="flex items-center justify-center">
    <p-fluid>
      <div class="flex items-center justify-center w-full">
        <div class="w-full max-w-xl rounded-xl">
          <div class="card flex flex-col gap-4 mt-3">
            <div data-testid="provider-registration-title" class="font-semibold text-2xl">
              {{ t('title') }}
            </div>
            <div data-testid="provider-registration-description">
              @if (isExistingAccount()) {
                {{
                  isAuthenticated()
                    ? t('descriptionExistingAccount')
                    : t('descriptionExistingAccountLogin')
                }}
              } @else {
                {{ isSso() ? t('descriptionSso') : t('description') }}
              }
            </div>

            @if (loading()) {
              <div class="flex justify-center">
                <i
                  data-testid="loading-spinner"
                  class="pi pi-spin pi-spinner"
                  style="font-size: 2rem"
                ></i>
              </div>
            }

            @if (errorKey() && !loading()) {
              <p-message severity="error" size="small" data-testid="error-message">
                {{ errorKey() | transloco }}
              </p-message>
            }

            @if (providerData() && !loading() && isExistingAccount() && !isAuthenticated()) {
              <div class="mt-4">
                <p-button
                  data-testid="provider-register-login-button"
                  [label]="'common.signIn' | transloco"
                  (onClick)="loginWithExistingAccount()"
                ></p-button>
              </div>
            }

            @if (providerData() && !loading() && (!isExistingAccount() || isAuthenticated())) {
              <form
                data-testid="provider-registration-form"
                [formGroup]="form"
                (ngSubmit)="onSubmit()"
                class="flex flex-col gap-4"
              >
                <app-form-field
                  id="tenant"
                  fieldName="tenant"
                  label="providerRegister.tenant"
                  disabled="true"
                ></app-form-field>

                <app-form-field
                  id="email"
                  fieldName="email"
                  label="providerRegister.email"
                  type="email"
                  disabled="true"
                ></app-form-field>

                <app-form-field
                  id="salesTaxNumber"
                  fieldName="salesTaxNumber"
                  label="providerRegister.salesTaxNumber"
                ></app-form-field>

                @if (needsPassword()) {
                  <app-form-field
                    id="password"
                    fieldName="password"
                    label="common.password"
                    type="password"
                  ></app-form-field>

                  <app-form-field
                    id="passwordRepeat"
                    fieldName="passwordRepeat"
                    label="account.register.passwordRepeat"
                    type="passwordRepeat"
                  ></app-form-field>
                }

                <div class="mt-4">
                  <p-button
                    data-testid="provider-register-button"
                    type="submit"
                    [label]="t('register')"
                    [loading]="submitting()"
                    [disabled]="form.invalid"
                  ></p-button>
                </div>
              </form>
            }
            @if (!loading() && !isExistingAccount()) {
              <div class="text-center mt-4">
                <span data-testid="already-have-account-text">{{
                  'account.register.alreadyHaveAccount' | transloco
                }}</span>
                <button
                  data-testid="sign-in-link"
                  type="button"
                  class="ml-2 text-blue-600 underline cursor-pointer bg-transparent border-none p-0"
                  (click)="goToLogin()"
                >
                  {{ 'common.signIn' | transloco }}
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    </p-fluid>
  </div>
</div>
